var module = angular.module('octopusApp.configuration');

module.controller('UserRoleEditController', function($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    var roleId = $stateParams["id"];

    $scope.team = null;
    $scope.availablePermissions = [];
    $scope.title = null;

    var buildAvailable = function(permissionDescriptions) {
        $scope.availablePermissions = _.chain(permissionDescriptions).map(function (d, k) {
            return {
                id: k,
                description: d.Description,
                selected: $scope.role.GrantedPermissions.indexOf(k) >= 0
            };
        }).sortBy("id").value();
    };

    isLoading.promise(octopusRepository.PermissionDescriptions.all().then(function (permissionDescriptions) {
        if (roleId) {
            isLoading.promise(octopusRepository.UserRoles.get(roleId).then(function (result) {
                $scope.role = result;
                $scope.role.CanBeRenamed = result.CanbeDeleted;
                pageTitle($scope.role.Name);
                $scope.title = $scope.role.Name;
                buildAvailable(permissionDescriptions);
            }));
        } else {
            $scope.role = { Id: null, Name: '', CanBeRenamed: true, CanBeDeleted: false, GrantedPermissions: [] };
            pageTitle("Create custom role");
            $scope.title = "Create custom role";
            buildAvailable(permissionDescriptions);
        }
    }));

    $scope.save = function() {
        $scope.role.GrantedPermissions = _.chain($scope.availablePermissions).filter(function (p) {
            return p.selected;
        }).map(function (p) {
            return p.id;
        }).value();

        isSaving.promise(octopusRepository.UserRoles.save($scope.role).then(function (result) {
            unsavedChanges.saved();
            $location.path("/configuration/roles");
        }));
    };
});










//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/roles/controllers/user_role_edit_controller.js
// module id = 397
// module chunks = 1